var validationMessages=[];

function checkIsEmpty(value) {
    if (typeof value == undefined || value == "") {
        return true;
    } else {
        return false;
    }
}

function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;
    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
}

function ignoreAddressValidation() {
    if ($("body.add-address-body").length > 0 || $("body.edit-address-body").length > 0) {
        var $input = $('<input type="hidden" name="ignoreValidation"/>').val('true');
        $('form:first').append($input);
    }
}

function initFlyoutHelp() {
    var $flyout = $('#flyout-help');
    var $flyoutMenu = $('#flyout-menu-help');
    var $flyoutBeeper = $('#flyout-beeper-help');
    var $flyoutAction = $('#button-flyout-help');

    $flyoutAction.click(function (e) {
        e.preventDefault();
        if ($flyout.hasClass('visible')) {
            $flyout.fadeOut(700);
        } else {
            $flyout.fadeIn(700);

        }
        $flyout.toggleClass('visible');
    });

    $flyoutMenu.mouseleave(function () {
        $flyout.removeClass('visible');
        $flyout.fadeOut(700);
    });
}

function initUserlane() {
    var userName = '';
    if ($('.welcome-message span').length) {
        userName = $('.welcome-message span').text().trim();
    }
    if (window.location.host.indexOf('dcc-dev') != -1 && ((getUrlParameter('demo') && getUrlParameter('demo') == 'on') || userName == 'Demo Benutzer')) {
        var lang = '/en';
        var userLang = navigator.language || navigator.userLanguage;
        if (userLang.indexOf('de') != -1) {
            lang = '/de';
        } else if (userLang.indexOf('it') != -1) {
            lang = '/it';
        } else if (userLang.indexOf('fr') != -1) {
            lang = '/fr';
        }
        var href = window.location.href;
        if(href.indexOf('/en') == -1 && href.indexOf('/de') == -1 && href.indexOf('/it') == -1 && href.indexOf('/fr') == -1) {
            href += lang;
        } else if (lang == '/en') {
            if(href.indexOf('/de') != -1) {
                href = href.replace('/de', lang);
            } else if (href.indexOf('/it') != -1) {
                href = href.replace('/it', lang);
            } else if (href.indexOf('/fr') != -1) {
                href = href.replace('/fr', lang);
            }
        } else if (lang == '/de') {
            if(href.indexOf('/en') != -1) {
                href = href.replace('/en', lang);
            } else if (href.indexOf('/it') != -1) {
                href = href.replace('/it', lang);
            } else if (href.indexOf('/fr') != -1) {
                href = href.replace('/fr', lang);
            }
        } else if (lang == '/it') {
            if(href.indexOf('/en') != -1) {
                href = href.replace('/en', lang);
            } else if (href.indexOf('/de') != -1) {
                href = href.replace('/de', lang);
            } else if (href.indexOf('/fr') != -1) {
                href = href.replace('/fr', lang);
            }
        } else if (lang == '/fr') {
            if(href.indexOf('/en') != -1) {
                href = href.replace('/en', lang);
            } else if (href.indexOf('/de') != -1) {
                href = href.replace('/de', lang);
            } else if (href.indexOf('/it') != -1) {
                href = href.replace('/it', lang);
            }
        }
        if (window.location.href != href) {
            window.location = href;
        }
        window.userlaneSettings = {app_id: 31631, lang: lang.replace('/','')};
        var userlaneScript = document.createElement('script');
        userlaneScript.setAttribute('src', 'https://cdn.userlane.com/userlane.js');
        document.body.appendChild(userlaneScript);
    }
}

function removeError(id) {
    $(id).removeClass('is-invalid');
    $(id).parent().find('.invalid-feedback').remove();
}

function showError(id, message) {
    if (!$(id).hasClass('is-invalid')) {
        $(id).addClass('is-invalid');
        $(id).parent().append('<div class="invalid-feedback">' + message + '</div>');
    }
}

function removeSelectError(id) {
    $(id).removeClass('is-invalid');
    $(id).parent().removeClass('is-invalid');
    $(id).parent().parent().find('.invalid-feedback').remove();
}

function showSelectError(id, message) {
    if (!$(id).hasClass('is-invalid')) {
        $(id).addClass('is-invalid');
        $(id).parent().addClass('is-invalid');
        $(id).parent().parent().append('<div class="invalid-feedback">' + message + '</div>');
    }
}

function validate(form) {
    var error = false;
    if (checkIsEmpty($('#role').val())) {
        error = true;
        showError('#role', validationMessages['NotNull.userAddresses.role']);
    } else {
        removeError('#company');
    }
    if (checkIsEmpty($('#company').val())) {
        error = true;
        showError('#company', validationMessages['NotNull.userAddresses.company']);
    } else {
        removeError('#company');
    }
    if (checkIsEmpty($('#street').val())) {
        error = true;
        showError('#street', validationMessages['NotNull.userAddresses.street']);
    } else {
        removeError('#street');
    }
    if (checkIsEmpty($('#houseno').val())) {
        error = true;
        showError('#houseno', validationMessages['NotNull.userAddresses.houseno']);
    } else {
        removeError('#houseno');
    }
    if (checkIsEmpty($('#zipcode').val())) {
        error = true;
        showError('#zipcode', validationMessages['NotNull.userAddresses.zipcode']);
    } else {
        removeError('#zipcode');
    }
    if (checkIsEmpty($('#city').val())) {
        error = true;
        showError('#city', validationMessages['NotNull.userAddresses.city']);
    } else {
        removeError('#city');
    }
    if (checkIsEmpty($('#country').val())) {
        error = true;
        showSelectError('#country', validationMessages['NotNull.userAddresses.country']);
    } else {
        removeSelectError('#country');
    }
    if (!error) {
        $(form).submit();
    }
}

$(function() {
    if ($('#language-select').length) {
        $('#language-select ul li a').each(function () {
            if ($(this).attr('href').indexOf('es') != -1 ||
                $(this).attr('href').indexOf('nl') != -1 ||
                $(this).attr('href').indexOf('pt') != -1) {
                $(this).parent().remove();
            }
        });
    }

    if (window.location.pathname.indexOf('register') != -1 || window.location.pathname.indexOf('profile') != -1) {
        $("#language option[value='es']").remove();
        $("#language option[value='nl']").remove();
        $("#language option[value='pt']").remove();
        $('#language').selectpicker('refresh');
    }

    initFlyoutHelp();
    ignoreAddressValidation();

    var language = window.location.pathname.substring(1, 3);

    if (window.location.pathname.indexOf('addresses') != -1) {
        validationMessages = [];
        var messagesUrl = window.location.protocol + '//' + window.location.host + '/' + language + '/profile/addresses/messages';
        $.getJSON(messagesUrl, function (data) {
            validationMessages = data;
        }).fail(function () {
            console.log("Error while receiving the validation messages.");
        });
    }

    var usersGuideBaseUrl = 'https://help.devolo-cc.com';
    if (window.location.host.indexOf('dcc-dev') != -1) {
        usersGuideBaseUrl = 'https://help-dcc-dev.devolo.net';
    } else if (window.location.host.indexOf('dcc-test') != -1) {
        usersGuideBaseUrl = 'https://help-dcc-test.devolo.net';
    } else if (window.location.host.indexOf('dcc-beta') != -1) {
        usersGuideBaseUrl = 'https://help-dcc-beta.devolo.net';
    }

    if (window.location.pathname.indexOf('dashboard') != -1) {
        var monitoringUrl = window.location.protocol + '//' + window.location.host + '/' + language + '/devolo-devices/monitoring/status';
        $.getJSON(monitoringUrl, function (data) {
            $('.btn-action-devolo-device-statistic').css('background-color', data['color']);
        }).fail(function () {
            console.log("Error while receiving the monitoring status.");
        });
    }

    var usersGuidePath = 'main';
    if (window.location.pathname.indexOf('hotspots') != -1) {
        usersGuidePath = 'dlan-hotspot';
    }

    var lang = 'en';
    switch (language) {
        case 'de':
            lang = 'de';
            break;
        case 'fr':
            lang = 'fr';
            break;
        case 'it':
            lang = 'it';
            break;
        default:
            break;
    }

    $('#flyout-users-guide').attr('href', usersGuideBaseUrl + '/business-solutions/' + usersGuidePath + '/' + lang);

    if ($('#button-action-devolo-device-statistic').length > 0) {
        $('#button-action-devolo-device-statistic').removeAttr('target');
    }

    initUserlane();
});
